const NGNbpayOptions = [
    {value: "ABBEYM", label: "Abbey Mortgage Bank"},
    {value: "ACCBANK", label: "Access Bank"},
    {value: "ACCBANKD", label: "Access Bank (Diamond)"},
    {value: "ALATBW", label: "ALAT by WEMA"},
    {value: "ASOSAL", label: "ASO Savings and Loans"},
    {value: "BOWENMB", label: "Bowen Microfinance Bank"},
    {value: "CEMCSB", label: "CEMCS Microfinance Bank"},
    {value: "CITIBANK", label: "Citibank Nigeria"},
    {value: "CMBANK", label: "Coronation Merchant Bank"},
    {value: "ECOBANK", label: "Ecobank Nigeria"},
    {value: "EkondoMB", label: "Ekondo Microfinance Bank"},
    {value: "EYOWO", label: "Eyowo"},
    {value: "FIDELITYB", label: "Fidelity Bank"},
    {value: "FIRSTBANK", label: "First Bank of Nigeria"},
    {value: "FIRSTCMB", label: "First City Monument Bank"},
    {value: "FSDHMBL", label: "FSDH Merchant Bank Limited"},
    {value: "GLOBUSB", label: "Globus Bank"},
    {value: "GUARATYTB", label: "Guaranty Trust Bank"},
    {value: "HACKMANMB", label: "Hackman Microfinance Bank"},
    {value: "HASALMB", label: "Hasal Microfinance Bank"},
    {value: "HERITAGEB", label: "Heritage Bank"},
    {value: "IBILEMB", label: "Ibile Microfinance Bank"},
    {value: "INFMFB", label: "Infinity MFB"},
    {value: "JAIZB", label: "Jaiz Bank"},
    {value: "KEYBANK", label: "Keystone Bank"},
    {value: "KUDABANK", label: "Kuda Bank"},
    {value: "MAYMFB", label: "Mayfair MFB"},
    {value: "ONEFINANCE", label: "One Finance"},
    {value: "PARABANK", label: "Parallex Bank"},
    {value: "PKARC", label: "Parkway - ReadyCash"},
    {value: "PETRAMBP", label: "Petra Mircofinance Bank Plc"},
    {value: "POLARISB", label: "Polaris Bank"},
    {value: "PROVIDUSB", label: "Providus Bank"},
    {value: "RANDMB", label: "Rand Merchant Bank"},
    {value: "RUBIESMFB", label: "Rubies MFB"},
    {value: "SPARKBANK", label: "Sparkle Microfinance Bank"},
    {value: "STANBICB", label: "Stanbic IBTC Bank"},
    {value: "STANDARDCB", label: "Standard Chartered Bank"},
    {value: "STERLINGB", label: "Sterling Bank"},
    {value: "SUNTRUST", label: "Suntrust Bank"},
    {value: "TAJBANK", label: "TAJ Bank"},
    {value: "TCFMFB", label: "TCF MFB"},
    {value: "TITANB", label: "Titan Bank"},
    {value: "UNIONBON", label: "Union Bank of Nigeria"},
    {value: "UNITEDBFA", label: "United Bank For Africa"},
    {value: "UNITYB", label: "Unity Bank"},
    {value: "VFDMBL", label: "VFD Microfinance Bank Limited"},
    {value: "WEMABANK", label: "Wema Bank"},
    {value: "ZENITHB", label: "Zenith Bank"},
    {value: "PAYCOM", label: "PAYCOM(opay) Bank"},
];

export default NGNbpayOptions;
